<section class="mt-4" style="overflow-x: auto;height: 70vh;">
  <section class="d-flex justify-content-between" style="gap: 5px;">
    <button type="submit" class="btn btn-dark mb-2" routerLink="/admin/manage-market"><i aria-hidden="true"
        class="fa fa-plus-circle"></i> Manage Character</button>
  </section>
  <table class="table table-hover white_box shadow">
    <thead>
      <tr>
        <th scope="col">#</th>
        <th scope="col">Character Name</th>
        <th scope="col">Character Image</th>
        <th scope="col">Character Description</th>
        <th scope="col">Role Assign</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of list; let i = index;">
        <th scope="row">{{i + 1}}</th>
        <th scope="row">{{item?.name}}</th>
        <td>
          <img loading="lazy" src="{{ imgUrl + item?.image }}" class="mr-2" style="height: 50px" alt="" />
        </td>
        <td>{{item?.description}}</td>
        <td width="500">
          <div class="d-flex">
            <select class="form-control" style="max-width: 20rem;" (change)="onRoleChange($event.target.value)">
              <option [value]="null">Add Role for Level</option>
              <option [value]="r.roleId" *ngFor="let r of (roleList || [])"> {{r?.roleName}}</option>
            </select>
            <span class="px-2 d-flex justify-content-center" style="align-items: center;">  
              <button type="button" class="btn btn-primary d-flex"
                (click)="addRoleToCharacter(item.id,(item?.RoleProfileCharacter || []))"><i class="fa fa-plus-circle mr-2"
                  title="Add Role" aria-hidden="true" style="font-size: 1.5rem;"></i> Add Role</button>
            </span>
          </div>
          <section class="row mt-1 mx-1" style="max-width: 35rem;">
            <span class="sub-cate my-1" style="width: fit-content;"
              *ngFor="let j of (item?.RoleProfileCharacter || [])">{{j?.role?.roleName || ''}} <i class="fa fa-times"
                aria-hidden="true" (click)="deleteMemberCharacterRelationship(j.roleProfileCharacterId)"></i></span>
          </section>
        </td>
        <td class="text-right">

        </td>
      </tr>
    </tbody>
  </table>
</section>